import RentalApplicationNavLink from './RentalApplicationNavLink';

export default RentalApplicationNavLink;
